import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component


import {
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  Stack,
  Typography,
  Breadcrumbs,
  Box,
  Toolbar,
  Modal,
  Paper,
} from "@mui/material";
import ToggleSet from "../Components/ToggleSet.jsx";
import { CrumbToggleScenario } from "../Components/CrumbToggles.jsx";
import { MoneyInflateEditor, MoneyInvestEditor } from "../App/GridMoneyInput.jsx";
import { ageFormatter, currencyFormatter, percent1Formatter, yearFormatter } from "../App/GridFormatters.jsx";
import { API_Client, APIs_Scenario } from "../App/api.jsx";
import LabelInput from "../App/setLabel.jsx";
import ChartView from "../App/ChartView.jsx";
import {
  empty_uuid,
  ftchPlus,
  FtchPlusError,
  getOptions,
  postOptions,
  putOptions,
  ScenarioUrl,
  ScenarioUrl_post,
  ScenarioUrl_spec,
} from "../App/Account_urls.jsx";
import { useWindowDimensions } from "../App/useWindowDimensions.jsx";

import { faCaretDown, faCircleInfo, faEdit, faStar, faTableCells } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ErrorBar } from "../Components/ErrorBar.jsx";
import { Help_FinancialGrid } from "../Dialogs/Help/Help_Grids.jsx";
import dayjs from "dayjs";
import { GoogleAnalyticsEvent } from "../Components/ga4.jsx";
import { gridColor, iconSize, myOwnFPColor } from "../App/GridRenderers.jsx";
import { gridTooltipRenderer } from "../App/GridRenderers.jsx";
import CppViewPort from "../Dialogs/Cpp/CppViewPort.jsx";
import GisViewPort from "../Dialogs/Gis/GisViewPort.jsx";
import IncomeViewPort from "../Dialogs/Income/IncomeViewPort.jsx";
import OasViewPort from "../Dialogs/Oas/OasViewPort.jsx";
import { GridCsv } from "../Components/GridCsv.jsx";
import { PdfBuild, PdfExport } from "../Dialogs/Pdf/Export.jsx";
import { InputSwitch } from "../Components/Inputs/Input_Check.jsx";
import GovbViewPort from "../Dialogs/Govb/GovbViewPort.jsx";
import { Arrayify } from "../Functions/utils.jsx";
import { useAuth } from "../App/useAuth.jsx";
import { TopOffset } from "../App/Navbar_bs.jsx";
import HelpIcon from "../Dialogs/Help/HelpIcon.jsx";
import CloseIcon from "../Components/CloseIcon.jsx";
import { getScenarioInputs, ScenarioInputsViewPort } from "../Dialogs/Accounts/ScenarioInputView.jsx";
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer-continued';
import { AddDialog } from "../Components/AddDialog.jsx";
import { InfoViewPort } from "../Dialogs/Accounts/TaxInfoView.jsx";
import AddSimpleAccount from "../Dialogs/Accounts/AddSimpleAccount.jsx";
import AddInvestAccount from "../Dialogs/Accounts/AddInvestAccount.jsx";
import AddGov from "../Dialogs/Accounts/AddGov.jsx";
import AddPropertyAccount from "../Dialogs/Accounts/AddPropertyAccount.jsx";
import AddLiabilityAccount from "../Dialogs/Accounts/AddLiabilityAccount.jsx";
import AddInvestLoanAccount from "../Dialogs/Accounts/AddInvestLoanAccount.jsx";
import AddDBPensionAccount from "../Dialogs/Accounts/AddDBPensionAccount.jsx";
import AddAnnuityAccount from "../Dialogs/Accounts/AddAnnuityAccount.jsx";
// import { themeAlpine } from "ag-grid-community";


// export const gridTheme = themeAlpine
//   .withParams({
//     // backgroundColor: "#1f2836",
//     // borderRadius: 4,
//     // browserColorScheme: "dark",
//     cellHorizontalPaddingScale: 0.4,
//     // chromeBackgroundColor: {
//     //   ref: "foregroundColor",
//     //   mix: 0.07,
//     //   onto: "backgroundColor"
//     // },
//     // columnBorder: false,
//     // foregroundColor: "#FFF",
//     // headerVerticalPaddingScale: 1,
//     spacing: 8,
//     // wrapperBorderRadius: 8
//     // --ag - grid - size: 1px;
//     // --ag-spacing: 4px;
//     size: 1,

//     headerHeight: 30,
//     headerColumnSeparatorDisplay: "show",
//     headerColumnSeparatorColor: "#c5c5c5",
//     headerColumnSeparatorHeight: 0.9,
//     headerColumnSeparatorWidth: 1,
//     headerColumnResizeHandleDisplay: "none",
//     headerBackgroundColor: "#f2f8fa",

//     borderColor: "#d8d8e6",
//     rowBorderColor: "#c9cccd",
//     columnBorderColor: "#aecdd7",
//     backgroundColor: "#f5f5f5",
//     oddRowBackgroundColor: "#f3f5f5",
//     // selectedRowBackgroundColor: rgb(52, 4, 106, 0.5),

//   });

export const UpdateColumnGroupIds = (cols, pkey) => {
  for (let i = 0; i < Arrayify(cols).length; i++) {
    if (cols[i].children !== undefined && cols[i].children !== null) {
      let key = ""
      if (cols[i].groupId !== undefined && cols[i].groupId !== null) {
        key = pkey + ":" + cols[i].headerName
      } else {
        key = cols[i].groupId
      }
      cols[i].children = UpdateColumnGroupIds(cols[i].children, key)
      cols[i].groupId = key
    }
  }
  return cols
}


const cellTooltip = (props) => {
  // ugh all this cause they deprecated tooltipField
  let ttf = props?.colDef?.context?.TooltipField
  if (ttf !== undefined && ttf !== null && ttf !== "") {
    // console.log(ttf)
    let tt = props.data[ttf]
    if (tt !== undefined) {
      // console.log(tt)
      return tt
    }
  }
}

export const UpdateTooltips = (cols) => {
  // console.log(cols)
  for (let i = 0; i < Arrayify(cols).length; i++) {
    if (cols[i].children !== undefined && cols[i].children !== null) {
      cols[i].children = UpdateTooltips(cols[i].children)
    }
    // console.log(cols[i])
    cols[i].tooltip = (data) => cellTooltip(data)
  }
  // console.log(cols)
  return cols
}


const moneyCellRule = {
  "cell-pinned": (params) => params.node.rowPinned,
  "cell-header-highlighted": (params) => IsCellHeaderClicked(params),
  "cell-credits-remaininig": (params) => CellMethod(params) === "Calculated_CreditsRemaining",

};
const percentCellRule = {
  "cell-pinned": (params) => params.node.rowPinned,
  "cell-header-highlighted": (params) => IsCellHeaderClicked(params),
};
const ageCellRule = {
  "cell-pinned": (params) => params.node.rowPinned,
  "cell-header-highlighted": (params) => IsCellHeaderClicked(params),
};

const shouldNotBeNegative = {
  "cell-pinned": (params) => params.node.rowPinned,
  "cell-bad": (params) => CellValue(params) < 0 && CellValue(params) >= -499,
  "cell-real-bad": (params) => CellValue(params) <= -500,
  "cell-header-highlighted": (params) => IsCellHeaderClicked(params),
};
const moneyCashFlow = {
  "cell-pinned": (params) => params.node.rowPinned,
  "cell-header-highlighted": (params) => IsCellHeaderClicked(params),
  "cell-cf-negative": (params) => !params.node.rowPinned && CellValue(params) < 0,
  "cell-cf-positive": (params) => !params.node.rowPinned && CellValue(params) >= 0,
  "cell-pinned": (params) => params.node.rowPinned,

};
const moneyEdittable = {
  "cell-pinned": (params) => params.node.rowPinned,
  "cell-header-highlighted": (params) => IsCellHeaderClicked(params),
  // "cell-user-input": (params) => HasUserInput(params),
  "cell-user-input": (params) => CellMethod(params) === "UserInput",
  "cell-propogated-input": (params) => CellMethod(params) === "Propogated",
  "cell-propogated-ignoredinput": (params) =>
    CellMethod(params) === "Propogated_ignoredInput",
  "cell-calculated-ignoredinput": (params) =>
    CellMethod(params) === "Calculated_ignoredInput",
  "cell-user-edited": (params) =>
    CellMethod(params) === "UserEdited" || CellEdited(params) === true,
  "cell-edittable": (params) => true,
};

const yearStarted = {
  "cell-pinned": (params) => params.node.rowPinned,
  "cell-started": (params) => CellExtra(params) === "Started",
  "cell-header-highlighted": (params) => IsCellHeaderClicked(params),
};

function CellValue(params) {
  if (params.value) {
    let tpv = typeof params.value
    if (tpv === "string") {
      let has = params.value.split(";");
      let v = parseInt(has[0]);
      return v;
    } else if (tpv === "number") {
      return params.value
    }
  }
  return false;
}
function CellMethod(params) {
  if (params.value && typeof params.value === "string") {
    let has = params.value.split(";");
    if (has.length > 1) {
      let json = JSON.parse(has[1]);
      return json.method;
    }
  }
  return "";
}

function CellEdited(params) {
  if (params.value && typeof params.value === "string") {
    let has = params.value.split(";");
    if (has.length > 1) {
      let json = JSON.parse(has[1]);
      return json.edited;
    }
  }
  return false;
}
function CellExtra(params) {
  if (params.value) {
    if (typeof params.value === "string") {
      let has = params.value.split(";");
      if (has.length > 1) {
        return has[1]
      }
    }
  }
  return false;
}

var headerClicked = ""
export function CellHeaderClicked(colId) {
  if (headerClicked === colId) {
    //console.log("reset column:" + colId)
    headerClicked = ""
  } else {
    //console.log("highligh column: ", colId)
    headerClicked = colId
  }
  return headerClicked
}
export const onHeaderClicked = (value) => {
  CellHeaderClicked(value.column.colId)
  value.api.refreshCells()
}

function IsCellHeaderClicked(params) {
  if (params.column && params.column.colId === headerClicked) {
    return true
  }
  return false;
}


export const columnTypes = {
  nonEditableColumn: { editable: false },
  // dateColumn: {
  //     filter: 'agDateColumnFilter',
  //     filterParams: { comparator: myDateComparator },
  //     suppressMenu: true
  // },
  money: {
    valueFormatter: currencyFormatter,
    width: 120,
    cellClassRules: moneyCellRule,
    tooltipComponent: gridTooltipRenderer,
  },
  money_shouldNotBeNegative: {
    valueFormatter: currencyFormatter,
    width: 120,
    cellClassRules: shouldNotBeNegative,
    tooltipComponent: gridTooltipRenderer,
  },
  money_cashflow: {
    valueFormatter: currencyFormatter,
    width: 120,
    cellClassRules: moneyCashFlow,
    tooltipComponent: gridTooltipRenderer,
  },
  money_edittable: {
    valueFormatter: currencyFormatter,
    width: 120,
    //      cellClass: 'cell-edittable',
    //      cellClass: moneyEdittable,
    cellClassRules: moneyEdittable,
    editable: true,
    // show this editor in a popup
    cellEditorPopup: true,
    // position the popup under the cell
    cellEditorPopupPosition: "under",
    cellEditor: MoneyInflateEditor,
  },
  money_investedittable: {
    valueFormatter: currencyFormatter,
    width: 120,
    //      cellClass: 'cell-edittable',
    //      cellClass: moneyEdittable,
    cellClassRules: moneyEdittable,
    editable: true,
    // show this editor in a popup
    cellEditorPopup: true,
    // position the popup under the cell
    cellEditorPopupPosition: "under",
    cellEditor: MoneyInvestEditor,
  },
  inflatable: {},
  uptoage: {},
  additional: {},
  spousePercentage: {},
  rateeditable: {},
  flatreturn: {},
  allreturn: {},

  // money_hasentry: {
  //   valueFormatter: currencyFormatter,
  //   width: 240,
  //   cellClassRules: moneyHasEntry,
  // },

  year: {
    valueFormatter: yearFormatter,
    width: 80,
    sort: "asc",
    filter: false,
    sortable: false,
    cellClassRules: yearStarted,
  },
  age: {
    valueFormatter: ageFormatter,
    width: 80,
    filter: false,
    sortable: false,
    cellClassRules: ageCellRule,
  },
  percent: {
    valueFormatter: percent1Formatter,
    width: 80,
    cellClassRules: percentCellRule,
    tooltipComponent: gridTooltipRenderer,
  },

};

export const autoSizeStrategy = {
  type: 'fitCellContents',
  defaultMinWidth: 40,
  // defaultMaxWidth: 120,
  skipHeader: false,
};


// DefaultColDef sets props common to all Columns
export const defaultColDef = {
  field: "",
  sortable: false,
  resizable: true,
  suppressMovable: true,
  width: 120,
  suppressSizeToFit: false,
  //suppressFieldDotNotation: true, // this probably works for column names with . // but there is no equiv in the charts ... so just do what we haves
  type: "rightAligned",
  wrapHeaderText: true,
  autoHeaderHeight: true,
};

const defaultColGroupDef = {
  sortable: false,
  resizable: true,
  suppressSizeToFit: false,
  width: 120,
  type: "rightAligned",
};



export const ColumnHeaderIcon = ({ displayName, icon, onClick, rotate = 0, direction = "row", showName = true }) => {
  return (
    <div className="custom-header">
      <Stack direction={direction} spacing={2}>
        {showName && (
          <span>{displayName}</span>
        )}
        <FontAwesomeIcon
          color={gridColor}
          size="lg"
          icon={icon}
          rotation={rotate}
          onClick={onClick}
        />
      </Stack>
    </div>
  )
}


export const GridCompareSelector = ({ show, onClose, onClick,
  clientJson,
  c_callback,
  uuids,
}) => {
  const [showGrid, setShowGrid] = useState(false)

  const myClick = () => {
    GoogleAnalyticsEvent("grid", "view", "compare", { action: "compare" })
    setShowGrid(true)
    onClick()
  }

  const myClose = () => {
    setShowGrid(false)
    //onClose()
  }

  return (
    <>
      {(show &&
        <>
          <Button
            variant="contained"
            size="small"
            sx={{ width: 260 }}
            onClick={myClick}
          >
            Compare Grids
          </Button>
          <Modal
            sx={{ overflow: "scroll", mx: 15, mt: TopOffset }}
            anchor="right"
            open={showGrid}
            onClose={myClose}
          >
            <Stack sx={{ mx: 4, mt: 0 }} spacing={2}>
              <Paper>
                <GridScenarioViewPort
                  clientJson={clientJson}
                  c_callback={c_callback}
                  uuids={uuids}
                  onClose={myClose}
                />
              </Paper>
            </Stack>
          </Modal>
        </>
      )}
    </>

  )
}


export const InputCompareSelector = ({ show, onClose, onClick,
  clientJson,
  c_callback,
  uuids,
}) => {
  const [showCompare, setShowCompare] = useState(false)

  const myClick = () => {
    GoogleAnalyticsEvent("grid", "view", "compare", { action: "compare" })
    setShowCompare(true)
    onClick()
  }

  const myClose = () => {
    setShowCompare(false)
    //onClose()
  }

  return (
    <>
      {(show &&
        <>
          <Button
            variant="contained"
            size="small"
            sx={{ width: 260 }}
            onClick={myClick}
          >
            Compare Inputs
          </Button>
          <AddDialog
            clientJson={null}
            c_callback={null}
            onClose={myClose}
            open={showCompare}
            clients={[]}
            client={""}
            label={"Scenario Input Comparison"}
            onClientChange={() => { }}
            noButtons={true}
            accountType="ScenarioInputCompare"
          >
            <InputScenarioViewPort
              clientJson={clientJson}
              uuids={uuids}
              onClose={myClose}
            />
          </AddDialog>
        </>
      )}
    </>

  )
}

export const InputScenarioViewPort = ({ clientJson,
  uuids,
  onClose,
}) => {
  // const [inputsS1, setInputsS1] = useState("")
  // const [inputsS2, setInputsS2] = useState("")
  // const [highlight, setHighlight] = useState([])
  const [results, setResults] = useState([])

  const getData = async () => {
    const results = await Promise.all(
      uuids.map(async (uuid, i) => {
        // Run your async operation
        const [s, h] = await getScenarioInputs(clientJson, uuid.uuid)

        // Return an object containing 2 (or more) values
        const h2 = h.map(item => (i === 0 ? "L" : "R") + "-" + item)
        return {
          inputs: s,
          highlights: h2
        };
      }))
    console.log(results)
    setResults(results)
  }

  useEffect(() => {
    getData()
  }, [])


  const rdvCustomStyles = {
    variables: {
      light: {
        diffViewerTitleBackground: myOwnFPColor, // Your custom background color
      },
      dark: {
        diffViewerTitleBackground: '#1e222b', // Your custom dark background color
      },
      titleBlock: {
        fontSize: '18px', // Adjust your title size here
        padding: '10px 15px', // Optional: adjust padding to fit the new size
      }
    }
  };


  return (
    <Stack spacing={2}>
      {Arrayify(results).map((r, i) => (
        <>
          {i > 0 && (
            <ReactDiffViewer
              key={"redv-" + i}
              oldValue={results[0].inputs}
              highlightLines={[results[0].highlights, r.highlights]}
              compareMethod={DiffMethod.WORDS}
              newValue={r.inputs}
              leftTitle={uuids[0].label}
              rightTitle={uuids[i].label}
              splitView={true}
              hideLineNumbers={true}
              showDiffOnly={false}
              extraLinesSurroundingDiff={0}
              hideSummary={true}
              styles={rdvCustomStyles}
            />
          )}
        </>
      ))}
    </Stack>

  )
}


export const GridScenarioViewPort = ({

  clientJson,
  c_callback,
  uuids,
  onClose,
}) => {
  const { winHeight, winWidth } = useWindowDimensions();
  const [client_, setClient_] = useState("")
  const [dataSet_, setDataSet_] = useState("")
  const [showSums_, setShowSums_] = useState(false);



  const getHieght = () => {
    let h = winHeight - 50 * 4;
    if (Arrayify(uuids).length > 1) {
      let length = uuids.length
      h -= (length - 1) * 75;
      h /= length
    }
    return h
  }

  const getWidth = () => {
    return ~~((winHeight - 2 * 20 * 4) / 1.5)

  }

  const onSetChange = (client, dataSet) => {
    setClient_(client)
    setDataSet_(dataSet)
  }

  const myClose = () => {
    setShowSums_(false)
    onClose()
  }

  const myShowSums = (v) => {
    setShowSums_(v)
  }



  return (
    <Stack spacing={0} >
      {/* < GridScenario
        clientJson={clientJson}
        c_callback={c_callback}
        scen_uuid={clientJson.Scenario.uuid}
        scen_name={clientJson.Scenario.label}
        height={getHieght()}
        onClose={myClose}
        dataSet_={dataSet_}
        client_={client_}
        onSetChange={onSetChange}
        comparison={Arrayify(uuids).length !== 0}
        showSums_={showSums_}
        onShowSums={myShowSums}

      /> */}
      {Arrayify(uuids).map((uuid, i) => (
        < GridScenario
          clientJson={clientJson}
          c_callback={c_callback}
          key={"gridid-cc1-" + i}
          scen_uuid={uuid.uuid}
          scen_name={uuid.label}
          height={getHieght()}
          onClose={myClose}
          dataSet_={dataSet_}
          client_={client_}
          onSetChange={onSetChange}
          comparison={Arrayify(uuids).length > 1}
          showSums_={showSums_}
          onShowSums={myShowSums}
          showDups={i === 0}
        />
      ))}


    </Stack>
  )


}








const GridScenario = ({ clientJson, c_callback,
  scen_name = null,
  scen_uuid,
  width,
  height,
  onClose,
  client_,
  dataSet_,
  onSetChange,
  showSums_,
  onShowSums,
  comparison,
  showDups = true,

}) => {
  const navigate = useNavigate();
  const { admin_r, features_r } = useAuth();
  const [admin] = useState(admin_r.current)
  const [features] = useState(features_r.current)

  const { winHeight, winWidth } = useWindowDimensions();

  const [errmsg, setErrmsg] = useState("")
  const [edited, setEdited] = useState(false);
  const gridRef = useRef(null); // Optional - for accessing Grid's API
  const clientData = useRef(null);
  const [clients, setClients] = useState([]);
  const [input, setInput] = useState();
  const [client, setClient] = useState("");
  const [dataSets, setDataSets] = useState([]);
  const [dataSet, setDataSet] = useState("");
  const [rowData, setRowData] = useState([]); // Set rowData to Array of Objects, one Object per Row
  const [changed, setChanged] = useState(false)
  const [topRowData, setTopRowData] = useState([]);
  const [bottomRowData, setBottomRowData] = useState([]);
  const [showSums, setShowSums] = useState(false);
  const [loading, setLoading] = useState(true)
  const [preparedBy, setPreparedBy] = useState("")
  const [executedDate, setEexecutedDate] = useState("")


  const [form, setForm] = useState({
    PostRunModified: false,
    Label: "",
    Locked: false,
    Favourite: false,
    Description: "",
  });
  const [whoWhen, setWhoWhen] = useState("");

  // Each Column Definition results in one Column.
  const [columnDefs, setColumnDefs] = useState([]);


  //  consuming Grid Event
  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  const scenName = () => {
    return (scen_name !== null ? scen_name : clientJson.Scenario.label)
  }

  useEffect(() => {
    Update(client_, dataSet_, showSums_)
  }, [client_, dataSet_, showSums_])




  const CppHeader = ({ displayName }) => {
    const [show, setShow] = useState(false);
    return (
      <>
        <ColumnHeaderIcon
          displayName={displayName}
          icon={faTableCells}
          onClick={() => { setShow(true) }}
        />
        <CppViewPort
          clientJson={clientJson}
          scen_uuid={scen_uuid}
          scen_name={scen_name}
          show={show}
          onClose={() => { setShow(false) }}
          name="CPP"
        />
      </>
    );
  };

  const QppHeader = ({ displayName }) => {
    const [show, setShow] = useState(false);
    return (
      <>
        <ColumnHeaderIcon
          displayName={displayName}
          icon={faTableCells}
          onClick={() => { setShow(true) }}
        />
        <CppViewPort
          clientJson={clientJson}
          scen_uuid={scen_uuid}
          scen_name={scen_name}
          show={show}
          onClose={() => { setShow(false) }}
          name="QPP"
        />
      </>
    );
  };

  const GisHeader = ({ displayName }) => {
    const [show, setShow] = useState(false);
    return (
      <>
        <ColumnHeaderIcon
          displayName={displayName}
          icon={faTableCells}
          onClick={() => { setShow(true) }}
        />
        <GisViewPort
          clientJson={clientJson}
          scen_uuid={scen_uuid}
          scen_name={scen_name}
          show={show}
          onClose={() => { setShow(false) }}
          name="GIS"
        />
      </>
    );
  };

  const OasHeader = ({ displayName }) => {
    const [show, setShow] = useState(false);
    return (
      <>
        <ColumnHeaderIcon
          displayName={displayName}
          icon={faTableCells}
          onClick={() => { setShow(true) }}
        />
        <OasViewPort
          clientJson={clientJson}
          scen_uuid={scen_uuid}
          scen_name={scen_name}
          show={show}
          onClose={() => { setShow(false) }}
          name="OAS"
        />
      </>
    );
  };
  const GovCreditHeader = ({ displayName }) => {
    const [show, setShow] = useState(false);
    return (
      <>
        <ColumnHeaderIcon
          displayName={displayName}
          icon={faTableCells}
          onClick={() => { setShow(true) }}
        />
        <GovbViewPort
          clientJson={clientJson}
          scen_uuid={scen_uuid}
          scen_name={scen_name}
          show={show}
          onClose={() => { setShow(false) }}
          name="Government Benefits"
        />
      </>
    );
  };


  const GrossHeader = ({ displayName }) => {
    const [show, setShow] = useState(false);
    return (
      <>
        <ColumnHeaderIcon
          displayName={displayName}
          icon={faTableCells}
          onClick={() => { setShow(true) }}
        />
        <IncomeViewPort
          clientJson={clientJson}
          scen_uuid={scen_uuid}
          scen_name={scen_name}
          show={show}
          onClose={() => { setShow(false) }}
          name="Income"
        />
      </>
    );
  };


  const TaxInfoHeader = ({ displayName }) => {
    const [show, setShow] = useState(false);
    return (
      <>
        <ColumnHeaderIcon
          displayName={displayName}
          icon={faCircleInfo}
          onClick={() => { setShow(true) }}
        />
        <InfoViewPort
          clientJson={clientJson}
          scen_uuid={scen_uuid}
          scen_name={scen_name}
          show={show}
          onClose={() => { setShow(false) }}
          name="TaxInfo"
          info="TaxText"
        />
      </>
    );
  };

  const TFSAInfoHeader = ({ displayName }) => {
    const [show, setShow] = useState(false);
    return (
      <>
        <ColumnHeaderIcon
          displayName={displayName}
          icon={faCircleInfo}
          onClick={() => { setShow(true) }}
        />
        <InfoViewPort
          clientJson={clientJson}
          scen_uuid={scen_uuid}
          scen_name={scen_name}
          show={show}
          onClose={() => { setShow(false) }}
          name="TFSAInfo"
          info="TFSAText"
        />
      </>
    );
  };
  const RRSPInfoHeader = ({ displayName }) => {
    const [show, setShow] = useState(false);
    return (
      <>
        <Stack direction="row" pacing={1}>
          <ColumnHeaderIcon
            displayName={displayName}
            icon={faCircleInfo}
            onClick={() => { setShow(true) }}
          />
          <InfoViewPort
            clientJson={clientJson}
            scen_uuid={scen_uuid}
            scen_name={scen_name}
            show={show}
            onClose={() => { setShow(false) }}
            name="RRSPInfo"
            info="RRSPText"

          />
        </Stack>
      </>
    );
  };

  const AccountEditInfoHeader = ({ displayName, column, showName, cl }) => {
    const setupMap = new Map([
      ["Employment", { class: AddSimpleAccount, type: "Employment", doRepeat: true }],
      ["Expenses", { class: AddSimpleAccount, type: "Expenses", doRepeat: true, dosp: true, doFrom: true, doReduceEoL: true, doTaxTreatment: true, }],
      ["CarryingCosts", { class: AddInvestAccount, type: "Expenses", doRepeat: true, dosp: true, doFrom: true, doReduceEoL: true, doTaxTreatment: true, }],
      ["Inheritance", { class: AddSimpleAccount, type: "Inheritance", doRepeat: true, dosp: true }],
      ["NonRegistered", { class: AddInvestAccount, type: "NonRegistered" }],
      ["InvestLoan", { class: AddInvestLoanAccount, type: "InvestLona", dosp: true }],
      ["TFSA", { class: AddInvestAccount, type: "Registered", oneRate: true }],
      ["TFFHSA", { class: AddInvestAccount, type: "Registered", oneRate: true }],
      ["RESP", { class: AddInvestAccount, type: "Registered", oneRate: true }],
      ["RRSP", { class: AddInvestAccount, type: "Retirement", doRepeat: true, dosp: true }],
      ["DCPP", { class: AddInvestAccount, type: "Retirement", doRepeat: true, dosp: true }],
      ["LIRA", { class: AddInvestAccount, type: "Retirement", doRepeat: true, dosp: true }],
      ["DBPensio ", { class: AddDBPensionAccount, type: "DBPension" }],
      ["Annuity ", { class: AddAnnuityAccount, type: "Annuity" }],
      ["CPP", { class: AddGov, type: "Gov" }],
      ["OAS", { class: AddGov, type: "Gov" }],
      ["GIS", { class: AddGov, type: "Gov" }],
      ["GovernmentBenefits", { class: AddGov, type: "Gov" }],
      ["Property", { class: AddPropertyAccount, type: "Property", dosp: true }],
      ["Liabilities", { class: AddLiabilityAccount, type: "Liability", dosp: true }],
    ])
    const [show, setShow] = useState(false);
    const myClose = () => {
      setShow(false)
    }
    let setup = null
    setup = setupMap.get(column.colDef.context.AccountType)
    return (
      <>
        <ColumnHeaderIcon
          displayName={displayName}
          icon={faEdit}
          onClick={() => { setShow(true) }}
          showName={showName}
        />
        <setup.class
          show={show}
          add={false}
          account={column.colDef.context.AccountName}
          account_uuid={column.colDef.context.AccountUuid}
          accountType={setup.type}
          close={myClose}
          client_p={cl}
          clientJson={clientJson}
          c_callback={c_callback}
          doRepeat={setup.doRepeat}
          dosp={setup.dosp}
          doReduceEoL={setup.doReduceEoL}
          doTaxTreatment={setup.doTaxTreatment}
          doFrom={setup.doFrom}
          oneRate={setup.oneRate}
          key={"gs_edit_account"}

        />
      </>
    );
  };

  const headerComponent = (headerComponents, props, cl) => {
    // console.log(props)
    // console.log(headerComponents)
    return (
      <Stack direction="row" spacing={0}>
        {headerComponents.map((Component, key) => (
          <Component
            {...props}
            showName={key === 0}
            key={key}
            cl={cl}
          />
        ))}
      </Stack>
    )
  }

  const AddHeaderComponents = (headers, list, cl) => {
    for (let hk in headers) {
      let h = headers[hk]
      for (let hc of list) {
        if (h.headerName === hc.name) {
          // console.log("Set HeaderComponent " + h.headerName)
          // have to set the client here, since otherwise 'client' is the original value before we lodaded data
          // so we need the current value
          h.headerComponent = (props) => headerComponent(hc.component, props, cl)
          headers[hk] = h
        } else if (h.context.AccountType == hc.AccountType && h.context.AccountName != "") {
          // console.log("Set HeaderComponen by AcctType " + h.headerName)
          h.headerComponent = (props) => headerComponent(hc.component, props, cl)
          headers[hk] = h

        }
      }
      if (h.children !== null) {
        h.children = AddHeaderComponents(h.children, list, cl)
      }
    }
    return headers
  }


  const HeaderComponentList = [
    { AccountType: "Gross", component: [GrossHeader] },

    { AccountType: "CPP", component: [CppHeader] },
    { AccountType: "QPP", component: [QppHeader] },
    { AccountType: "GIS", component: [GisHeader] },
    { AccountType: "OAS", component: [OasHeader] },
    { AccountType: "Credits", component: [GovCreditHeader] },

    // { AccountType: "CPP", component: [CppHeader, AccountEditInfoHeader] },
    // { AccountType: "QPP", component: [QppHeader, AccountEditInfoHeader] },
    // { AccountType: "GIS", component: [GisHeader, AccountEditInfoHeader] },
    // { AccountType: "OAS", component: [OasHeader, AccountEditInfoHeader] },
    // { AccountType: "Credits", component: [GovCreditHeader, AccountEditInfoHeader] },
    { name: "Tax*", component: [TaxInfoHeader] },
    // // { name: "", AccountType: "TFSA", component: TFSAInfoHeader },
    // // { name: "", AccountType: "RRSP", component: RRSPInfoHeader },
    // { AccountType: "Expenses", component: [AccountEditInfoHeader] },
    // { AccountType: "CarryingCost", component: [AccountEditInfoHeader] },
    // { AccountType: "Employment", component: [AccountEditInfoHeader] },
    // { AccountType: "NonRegistered", component: [AccountEditInfoHeader] },
    // { AccountType: "InvestLoan", component: [AccountEditInfoHeader] },
    // { AccountType: "TFSA", component: [AccountEditInfoHeader] },
    // { AccountType: "TFFHSA", component: [AccountEditInfoHeader] },
    // { AccountType: "RDSP", component: [AccountEditInfoHeader] },
    // { AccountType: "RRSP", component: [AccountEditInfoHeader] },
    // { AccountType: "LIRA", component: [AccountEditInfoHeader] },
    // { AccountType: "DCPP", component: [AccountEditInfoHeader] },
    // { AccountType: "DBPension", component: [AccountEditInfoHeader] },
    // { AccountType: "Annuity", component: [AccountEditInfoHeader] },
    // { AccountType: "Property", component: [AccountEditInfoHeader] },
    // { AccountType: "Liabilities", component: [AccountEditInfoHeader] },
  ]



  const Update = (cl, ds, ss) => {
    setClient(cl);
    setDataSet(ds);
    setShowSums(ss);

    // console.log(cl)
    // console.log(ds)
    // console.log(ss)

    if (clientData.current && clientData.current[cl] && clientData.current[cl][ds]) {

      // console.log(cl);
      // console.log(ds);
      // console.log(clientData.current);

      // this adds icons (components) to these column headers
      let headers = AddHeaderComponents(clientData.current[cl][ds].Headers, HeaderComponentList, cl)
      headers = UpdateTooltips(headers)
      setColumnDefs(UpdateColumnGroupIds(headers, "_Top_"));

      setRowData(clientData.current[cl][ds].Data);
      updateSums(ss, cl, ds)
    }
    // console.log("Set Row Data")
  };

  const postRerun = async () => {
    setLoading(true)
    setRowData([])
    console.log(input);

    var url = ScenarioUrl_post(clientJson)
    var req = postOptions;

    let json = {
      uuid: clientJson.Scenario.uuid,
      Label: form.Label,
      Locked: form.Locked,
      Favourite: form.Favourite,
      Desciption: form.Description,
      NoInput: true,
    };
    req.body = JSON.stringify(json);
    ftchPlus(url, req)
      .then((response) => {
        console.log(response.Uuid);
        setEdited(false);
        getData();
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
        FtchPlusError(error)
      });
  }


  //"/client/{cid}/scenario/{sid}/account/{account}/year/{year}",
  const putEdit = async (c_uuid, account, account_uuid, year, edit) => {
    let accId = "/account" + (account_uuid === empty_uuid ? "/" + account : "_uuid/" + account_uuid)
    var url =
      API_Client +
      c_uuid +
      APIs_Scenario +
      "/" +
      clientJson.Scenario.uuid +
      accId +
      "/year/" +
      year;
    console.log(url);
    var req = putOptions;
    edit.AccountName = account
    edit.AccountUuid = account_uuid
    edit.Year = NumberOrZero(year)
    req.body = JSON.stringify(edit);
    ftchPlus(url, req)
      .then((response) => {
        console.log(response.Uuid);
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
        FtchPlusError(error)
      });
  }

  const putLabel = async () => {
    var url = ScenarioUrl(clientJson, "info", "");
    console.log(url);
    var req = putOptions;
    req.body = JSON.stringify(form);
    ftchPlus(url, req)
      .then((response) => {
        console.log(response.Uuid);
        let scen = {
          ...clientJson.Scenario,
          label: form.Label,
          readonly: form.Locked,
        };
        let json = { ...clientJson, Scenario: scen };
        c_callback(json);
      })
      .catch((error) => {
        console.log(error.message);
        setErrmsg(error.message)
        FtchPlusError(error)
      });
  };

  const getData = async () => {
    setLoading(true)
    setRowData([])
    console.log(clientJson);
    if (scen_uuid !== null && scen_uuid !== empty_uuid) {
      console.log(clientJson.Scenario);
      var url = ScenarioUrl_spec(clientJson, scen_uuid, "", "");

      GoogleAnalyticsEvent("grid", "view", "scenario", { action: "view", type: "scenario" })

      ftchPlus(url, getOptions)
        .then((json) => {
          console.log(json);
          clientData.current = json.ClientData;
          setInput(json.Input);
          setClients(json.Clients);
          setDataSets(json.DataSets);
          const cl = json.Clients[0];
          setClient(cl);
          const ds = json.DataSets[0];
          setDataSet(ds);
          onSetChange(cl, ds)
          setForm(json.Info);
          let d = new dayjs(json.Info.Executed.When);
          setWhoWhen(
            json.Info.Executed.Who +
            " @ " +
            d.format("D-MMM-YYYY") +
            "  " +
            d.format("H:mm")
          );
          setPreparedBy(json.Info.Executed.Who)
          setEexecutedDate(d.format("D-MMM-YYYY") + "  " + d.format("H:mm"))
          Update(cl, ds, showSums);
          setLoading(false)


        })
        .catch((error) => {
          console.log(error.message);
          setErrmsg(error.message)
          FtchPlusError(error)
          setLoading(false)

        });
    }

  };



  const btnClientChanged = (value) => {
    // console.log("chart client changed: " + value);
    if (onSetChange !== null) {
      onSetChange(value, dataSet)
    } else {
      Update(value, dataSet, showSums);
    }

  };

  const btnDataSetChanged = (value) => {
    // console.log("chart dataset changed: " + value);
    if (onSetChange !== null) {
      onSetChange(client, value)
    } else {
      Update(client, value, showSums);
    }
  };

  // load data from sever
  useEffect(() => {
    setErrmsg("")
    setChanged(false)

    //setRowData([])
    getData();
  }, [clientJson]);

  const myShowSums = (n, v) => {

    onShowSums(v)
  }

  const updateSums = (show, cl, ds) => {
    setTopRowData([])
    setBottomRowData([])
    if (show) {
      if (clientData.current &&
        clientData.current[cl] &&
        clientData.current[cl][ds] &&
        clientData.current[cl][ds].TopRow) {
        // console.log("do Agg")
        clientData.current[cl][ds].TopRow[0].year = "Aggregate"
        for (let i = 0; i < clients.length; i++) {
          clientData.current[cl][ds].TopRow[0][clients[i] + ":age"] = ""
        }

        setTopRowData(Arrayify(clientData.current[cl][ds].TopRow))
      }
    }
  }


  const displayShowSums = () => {
    if (clientData.current &&
      clientData.current[client] &&
      clientData.current[client][dataSet] &&
      clientData.current[client][dataSet].TopRow) {
      return myShowSums
    }
    return null
  }


  const onStoreInfo = (label, description) => {
    setForm({ ...form, Label: label, Description: description });
    setChanged(true)
  };

  const onSave = () => {
    console.log("Save Scenario");
    putLabel();
    setChanged(false)
  };
  const onRerun = () => {
    postRerun();
  };

  const Undo = () => {
    gridRef.current.api.undoCellEditing();
  };
  const Redo = () => {
    gridRef.current.api.redoCellEditing();
  };

  const onGridReady = useCallback((event) => {
    event.api.autoSizeAllColumns();
  }, []);

  const onFirstDataRendered = useCallback((event) => {
    event.api.autoSizeAllColumns();
  }, []);

  const onRowDataUpdated = useCallback((event) => {
    event.api.autoSizeAllColumns();
  }, []);

  // none of this works
  // const onGridReady =
  //   ((params) => {
  //     // gridRef.current.api.sizeColumnsToFit();
  //     gridRef.current.api.autoSizeAllColumns();
  //     console.log("Size columns GR")
  //   },
  //     []);
  // const onFirstDataRendered =
  //   ((params) => {
  //     // gridRef.current.api.sizeColumnsToFit();
  //     gridRef.current.api.autoSizeAllColumns();
  //     console.log("Size columns FD")
  //     window.setTimeout(() => {
  //       const colIds = gridRef.current.columnApi
  //         .getAllColumns()
  //         .map((c) => c.colId);
  //       gridRef.current.columnApi.autoSizeColumns(colIds);
  //     }, 50);
  //   },
  //     []);

  const defData = {
    method: "",
    edited: false,
    value_initial: 0,
    up_to_age: 0,
    percent_spousal: 0,
    actual: false,
    additional: false,
    inflate: false,
    inflate_base_year: new Date().getFullYear() - 1,
    inflate_threshold: 0,
  };

  const NumberOrZero = (value) => {
    return (value ? Number(value) : 0)
  }

  const onCellValueChange = (params) => {
    //console.log("OnCellValueChange");

    if (clientJson.readonly || clientJson.Scenario.readonly) {
      return;
    }
    console.log("OnCellValueChange");

    if (params.newValue) {
      let has = params.value.split(";");
      if (has.length > 1) {
        let json = JSON.parse(has[1]);
        json.value_initial = NumberOrZero(json.value_initial);
        json.up_to_age = NumberOrZero(json.up_to_age);
        json.percent_spousal = NumberOrZero(json.percent_spousal);
        json.inflate_base_year = NumberOrZero(json.inflate_base_year);
        json.inflate_threshold = NumberOrZero(json.inflate_threshold);
        setEdited(true);
        //console.log(params.column.colDef.headerName);
        //console.log(params.column.colDef.context);


        let uuid = client === clients[0] ? clientJson.uuid : clientJson.s_uuid;
        putEdit(uuid, params.column.colDef.headerName, params.column.colDef.context.AccountUuid, params.data.year, json);
      }
    }
  };

  const getHeight = () => {
    return height;
  };

  const FindHeaderName = (headers, name) => {
    if (headers !== undefined && headers !== null && Array.isArray(headers)) {
      let na = headers.filter((h) => h.headerName === name);
      if (na.length === 1) {
        return true
      }
      let hc = headers.filter((h) => h.children !== undefined && h.children.length > 0);

      for (let i = 0; i < hc.length; i++) {
        let c = hc[i];
        if (FindHeaderName(c.children, name)) {
          return true
        }
      }
    }
    return false
  }

  const gridRefFn = () => {
    return gridRef
  }


  return (
    // <div style={{ display: "flex" }}>
    <Container maxWidth="true">

      <Stack spacing={2}>
        <Toolbar >
          <Box sx={{ flexGrow: 1, alignItems: "flex-start" }}>

            <Breadcrumbs maxItems={6} separator="›">
              {clientJson.BreadCrumbs}
            </Breadcrumbs>
            <Stack direction="row" spacing={2}>
              <div>
                <Stack direction="row" spacing={2}>
                  {(form.PostRunModified || edited) && (
                    <ToggleSet
                      set={["Modified"]}
                      current="Modified"
                    />
                  )}
                  <CrumbToggleScenario
                    set={clients}
                    current={client}
                    onChange={btnClientChanged}
                    crumbClose={(json) => {
                      c_callback(json);
                      navigate("/scenarioSelect");
                    }}
                    clientJson={clientJson}
                    scen_name={scen_name}
                  />
                  <ToggleSet
                    set={dataSets}
                    current={dataSet}
                    onChange={btnDataSetChanged}
                  />
                  <InputSwitch
                    value={showSums}
                    label="Aggregate"
                    disabled={displayShowSums() === null}
                    onChange={myShowSums}
                  />
                  {!comparison && (
                    <>
                      {(true || admin || features.includes("raw")) && (
                        <Link
                          to={ScenarioUrl(clientJson, "", "?detail=true")}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Button variant="contained">Raw</Button>
                        </Link>
                      )}
                    </>
                  )}
                </Stack>
              </div>

              {!comparison && (
                <>
                  <div>
                    <Stack direction="row" spacing={2}>
                      <Box>
                        <Stack sx={{ mt: 2 }}>
                          <FontAwesomeIcon
                            icon={faStar}
                            color={form.Favourite ? "gold" : "grey"}
                            size={iconSize}
                            // className="mr-4 App-icon"
                            onClick={() => {
                              setForm({
                                ...form,
                                Favourite: !form.Favourite,
                              });
                              setChanged(true)
                            }}
                          ></FontAwesomeIcon>
                        </Stack>
                      </Box>
                      <FormControlLabel
                        sx={{ ml: 4, mr: 0 }}
                        labelPlacement="end"
                        size="small"
                        control={
                          <Checkbox
                            checked={form.Locked}
                            size="small"
                            onChange={(e) => {
                              setForm({
                                ...form,
                                Locked: e.target.checked,
                              });
                              setChanged(true)
                            }}
                          />
                        }
                        label="Locked"
                      />
                    </Stack>
                  </div>
                  <LabelInput
                    label={form.Label}
                    description={form.Description}
                    onChange={onStoreInfo}
                    onSave={onSave}
                    disabled={
                      clientJson.readonly ||
                      (clientJson.Scenario.readonly && form.Locked) ||
                      !changed
                    }
                  />
                </>
              )}


            </Stack>
          </Box>
          <Box sx={{ alignItems: "flex-start", justifyContent: "flex-end" }}>
            {!comparison && (
              <Stack direction="row" spacing={2} sx={{ alignItems: "flex-start" }}>
                <ChartView clientJson={clientJson} />
                {(true || admin || features.includes("pdf")) && (
                  <>
                    <PdfExport
                      clientJson={clientJson}
                    />
                    <PdfBuild
                      clientJson={clientJson}
                      preparedBy={preparedBy}
                      executedDate={executedDate}
                    />
                  </>
                )}

                <ScenarioInputsViewPort
                  clientJson={clientJson}
                />
                <GridCsv
                  filename={"MyOwnFP " + scenName() + " " + client + " " + dataSet + " Scenario"}
                  name={"Scenario"}
                  scenario={scenName()}
                  client={client}
                  dataset={dataSet}
                  gridRefFn={gridRefFn}
                />

                <Button
                  variant="contained"
                  disabled={
                    clientJson.readonly ||
                    clientJson.Scenario.readonly ||
                    (!form.PostRunModified && !edited)
                  }
                  onClick={onRerun}
                >
                  ReRun
                </Button>
              </Stack>
            )}
            {comparison && (
              <Stack direction="row" spacing={2} sx={{ alignItems: "flex-start" }}>
                <HelpIcon
                  show={showDups}
                />
                <CloseIcon
                  onClick={onClose}
                  show={showDups}
                />
              </Stack>
            )}
          </Box>
        </Toolbar>

        {/* On div wrapping Grid a) specify theme CSS Class Class and b) sets Grid size */}
        {/*    <div className="ag-theme-alpine-dark"  (style={{width: '90%', height: 1000}}}>*/}
        <div
          className="ag-theme-alpine"
          style={{ width: "100%", height: height }}
        >
          {/*<div ag-grid="gridOptions" className="ag-theme-dark">*/}

          <AgGridReact
            ref={gridRef} // Ref for accessing Grid's API
            // theme={gridTheme}
            rowData={rowData} // Row Data for Rows
            pinnedTopRowData={topRowData}
            pinnedBottomRowData={bottomRowData}
            rowHeight={32}
            columnDefs={columnDefs} // Column Defs for Columns
            defaultColDef={defaultColDef} // Default Column Properties
            columnTypes={columnTypes}
            defaultColGroupDef={defaultColGroupDef}
            tooltipShowDelay={1200}
            animateRows={false} // Optional - set to 'true' to have rows animate when sorted
            // onGridReady={onGridReady}
            // onFirstDataRendered={onFirstDataRendered}
            // onPinnedRowDataChanged={onFirstDataRendered}
            onRowDataUpdated={onRowDataUpdated}
            // rowSelection={mode = "multiRow"}
            suppressClickEdit={comparison} // disable all editing in comparison mode
            onCellClicked={cellClickedListener} // Optional - registering for Grid Event
            undoRedoCellEditing={true}
            undoRedoCellEditingLimit={50}
            onCellValueChanged={onCellValueChange}
            onColumnHeaderClicked={onHeaderClicked}

            reactiveCustomComponents={false}
            // suppressClipboardPaste={true}  // enterprise only
            //enableRangeSelection={true} // enterprise only
            // suppressCopySingleCellRanges={true}  // enterprise only
            autoSizeStrategy={autoSizeStrategy}
            autoSizePadding={8}
            loading={loading}
          />
        </div>
        {/* <Grid container justify="flex-end"> */}
        <Stack spacing={2}>
          {/* <Stack direction="row" spacing={2}>
            <InputCheck
              label="Default Comment"
              name="DefaultComment"
            //onChange={onChange_any}
            //value={form.DefaultComment}
            />
            <Input_Comment
              comment={form.DefaultComment ? "xx" : form.Comment}
              //onChange={onChange_t}
              disabled={form.DefaultComment}
            />
            
          </Stack> */}

          <ErrorBar error={errmsg} />
          <Help_FinancialGrid />
          {comparison === false && (
            <Typography id="1" variant="body2" gutterBottom>
              {whoWhen}
            </Typography>
          )}
        </Stack>
        {/* </Grid> */}
      </Stack >
    </Container >
    // </div>
  );
};

export default GridScenario;
